import CallService from "../projects/cc/services/CallService";
import { Customer } from "~/types";
import {
  getCleanedCustomerNumber,
  getCustomerUriInfo,
} from "~/projects/cc/utils/callCenterHelper";

interface CcDTop {
  bringToFront: () => Promise<void>;
  notifyCustomerCalling: (
    number: string,
    customer: Customer | null,
  ) => Promise<void>;
}

declare global {
  interface Window {
    ccDTop: CcDTop | undefined;
  }
}

function desktopFuncOnly(
  target: any,
  propertyKey: string,
  descriptor: PropertyDescriptor,
) {
  const originalMethod = descriptor.value;

  descriptor.value = function (...args: any[]) {
    if (typeof window.ccDTop !== "object") return;
    return originalMethod.apply(this, args);
  };

  return descriptor;
}

export default class DesktopIntegration {
  private initDone = false;

  public init(callService: CallService) {
    if (this.initDone) {
      return;
    }
    this.initDone = true;

    const { $listen } = useNuxtApp();
    $listen("progress", (e) => {
      if (e.direction === "incoming") {
        const { phoneNumber } = getCustomerUriInfo(
          callService.getCallerUri() || "",
        );
        const number = getCleanedCustomerNumber(phoneNumber);
        console.log("invoking desktop app functions if in desktop mode");
        this.bringToFront();
        this.notifyCustomerCalling(number, null);
      }
    });
  }

  /**
   * Returns whether the app is running in a desktop app
   */
  isDesktopApp(): boolean {
    return typeof window.ccDTop === "object";
  }

  /**
   * Brings the desktop app to the front of other applications
   */
  @desktopFuncOnly
  bringToFront(): void {
    window.ccDTop?.bringToFront();
  }

  /**
   * Shows a desktop notification of incoming call. customer can be null
   */
  @desktopFuncOnly
  notifyCustomerCalling(number: string, customer: Customer | null) {
    window.ccDTop?.notifyCustomerCalling(number, customer);
  }
}
